module.exports = __webpack_public_path__ + "img/facebook.a51cd54a.svg";